<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">FAQ 구분</th>
          <td>
            <div class="item">
              <select name="" id="" class="i_sel" style="width:260px" v-model="categorySeq">
                <option
                  v-for="category in categoryListForCreate"
                  :value="category.categorySeq"
                >{{ category.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">제목</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="제목을 입력하세요." v-model="title">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">내용</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="9" class="i_ta type_full lineless" placeholder="상세내용을 입력하세요." v-model="content"></textarea>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a href="#none" class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="editFaq" v-if="faqSeq">수정</button>
      <button type="button" class="bt_base primary large_h" @click="createFaq" v-else>저장</button>
      <button type="reset" class="bt_base gray large_h" @click="deleteFaq" v-if="faqSeq">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const adminCategoryModule = "adminCategoryModule"
const adminFaqModule = 'adminFaqModule'

export default {
  data () {
    return {
      faqSeq: this.$route.query.faqSeq,
      categorySeq: '',
      title: '',
      content: ''
    }
  },

  methods: {
    ...mapActions(adminFaqModule, [
      'requestCreateFaq',
      'requestFaq',
      'requestEditFaq',
      'requestDeleteFaqs'
    ]),

    ...mapActions(adminCategoryModule, [
      'requestCategoryListForCreate'
    ]),

    toList () {
      this.$router.push({ name: "FaqManageListPage" })
    },

    async createFaq() {
      const {title, content, categorySeq} = this
      if (await this.requestCreateFaq({title, content, categorySeq})) {
        this.$router.push({ name: "FaqManageListPage" })
      }
    },

    async editFaq () {
      const {faqSeq, title, content, categorySeq} = this
      if (await this.requestEditFaq({faqSeq, title, content, categorySeq})) {
        this.$router.push({ name: "FaqManageListPage" })
      }
    },

    async deleteFaq () {
      if (confirm("FAQ를 삭제하시겠습니까?")) {
        let deleteList = []
        deleteList.push(this.faqSeq)
        if (await this.requestDeleteFaqs(deleteList)) {
          alert("삭제가 완료됐습니다")
          this.$router.push({ name: 'FaqManageListPage' })
        }
      }
    }
  },

  computed: {
    ...mapState(adminFaqModule, [
      'faq'
    ]),
    ...mapState(adminCategoryModule, [
      'categoryListForCreate'
    ])
  },

  async mounted() {
    await this.requestCategoryListForCreate('FAQ')
    if (this.$route.query.faqSeq) {
      await this.requestFaq(this.$route.query.faqSeq);

      this.title = this.faq.title;
      this.content = this.faq.content;
      this.categorySeq = this.faq.categorySeq
    } else {
      this.categorySeq = this.categoryListForCreate[0].categorySeq
    }
  }
}
</script>
<style lang="">
    
</style>